/* styles */
import useStyles from './useStyles'
import { Checkbox, Typography } from '@mui/material'


import { namesTypesTraduc } from '../../../../../utils/traducTypes'
import ModalMenuItemUserOrg from '../../Modals/ModalMenuUserOfOrg'

function TableItem ({
  item,
  id,
  setLoading,
  types,
  typesComercial,
  typesStatus
}) {
  const classes = useStyles()

  // traduc type user with organizationUserTypeCode, return name traduc
  function traducName (code) {
    let name = null

    namesTypesTraduc.map((typeTraduc) => {
      if (typeTraduc.code === code) {
        name = typeTraduc.name
      }
      return name
    })

    return name
  }

  const getIconStatus = (status) => {
    if (status) {
      switch (status.userStatusCode) {
        case 'ACTIVE':
          return (<Typography className={classes.itemStatusActive}>Activo</Typography>

          )
        case 'WAITING_VALIDATION':
          return (
            <Typography className={classes.itemStatusWaiting}>Esperando validación</Typography>
       
          )
        case 'BLOCKED':
          return (
            <Typography className={classes.itemStatusInactive}>Bloqueado</Typography>
       
          )
        case 'INACTIVE':
          return (
            <Typography className={classes.itemStatusInactive}>Inactivo</Typography>
        
          )
        // no funciona
        case 'SUSPENDED':
          return (
             <Typography className={classes.itemStatusInactive}>Suspendido</Typography>
         
          )

        default:
          return (<Typography className={classes.itemStatusActive}> - -</Typography>
          
          )
      }
    }
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>{getIconStatus(item.status)}</td>

        <td className={classes.itemName}>{item.account?.firstName || '- -'}</td>
        <td className={classes.itemLastName}>
          {item.account?.lastName || '- -'}
        </td>
        <td className={classes.itemEmail}>{item.account?.email || '- -'}</td>
        <td className={classes.itemTypeUser}>
          {traducName(item.type?.organizationUserTypeCode) || '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItemUserOrg
            item={item}
            setLoading={setLoading}
            types={types}
            typesComercial={typesComercial}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
